import React from 'react';

import { Typography } from '@mui/material';

import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';

const MuiCardBaseShortDescription: React.FC<{
    description?: string;
    truncateDescriptionAt?: number;
}> = ({ description, truncateDescriptionAt }) => {

  const truncateSx = truncateDescriptionAt ? getTextTruncationSx(truncateDescriptionAt) : {};

  return description ? <Typography
    variant='body2'
    color='text.secondary'
    sx={truncateSx}
    dangerouslySetInnerHTML={{ __html: description }}
  /> : null;
};

export default MuiCardBaseShortDescription;
